import accountsPayableFullcont from "./accountsPayable-fullcont.html";

const dialog = require("../../../../../components/dialog/dialog");
const fullcontEntity = require("../../../../../components/fullcont/fullcont-entity");
const fullcontHandler = require("../../../../../components/fullcont/fullcont-handler");
const fullcontReport = require("../../../../../components/fullcont/fullcont-report");
const accountsPayableDt = require("./accountsPayable-dt");
const accountsPayableMenu = require("./accountsPayable-menu");
const { formCopy } = require("./accountsPayable-fullcont-form");
const { form } = require("./accountsPayable-fullcont-form");
const MtGenerator = require("./accountsPayable-multitable-generator");
const snack = require("../../../../../components/snack/snack");
// const {accountsPayableMT} = require('./accountsPayable-fullcont-multitable')
const accountsPayableMT = undefined; //no MT just add this like undefined
const accountsPayableFetch = require("./accountsPayable-fetch");
const accountsPayable = require("./accountsPayable");
const style = require("../../../../../components/report/report-style");
const css = style.get();

let iframe;
let topData = null;
let tableData = null;
/****************ELEMENTS*****************/
var htmlFc = {};
var HTMLwasSelected = false;

function HTMLselect(detail) {
  fullcontHandler.HTMLselect(
    "accountsPayable", //database table name****
    "accountsPayable", //dest entity on js
    "accountsPayable-fullcont",
    accountsPayableFullcont,
    form,
    formCopy,
    accountsPayableMT,
    editDialog,
    deleteDialog,
    dtCall,
    htmlFc
  );

  HTMLwasSelected = true;
  iframe = document.getElementById("reportIframe");
  // htmlFc.hasFiles = true
  // fullcontHandler.rightsControl(htmlFc)
} /**/

export function start(detail) {
  //console.log('accountsPayable-dt 5>', detail)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
} /**/

const obj = {
  addOne: {
    start: (detail) => {
      addOne(detail, htmlFc);
    },
  },
  cancelEdit: {
    start: (detail) => {
      fullcontEntity.cancelEdit(detail, htmlFc);
    },
  },
  deleteEntity: {
    start: (detail) => {
      fullcontEntity.deleteEntity(detail, htmlFc);
    },
  },
  deleteFromDialog: {
    start: (detail) => {
      deleteFromDialog(detail, htmlFc);
    },
  },
  discard: {
    start: (detail) => {
      fullcontHandler.discard(detail, htmlFc);
    },
  },
  fullcontOptions: {
    start: (detail) => {
      accountsPayableMenu.start(detail, "htmlDt", htmlFc);
    },
  },
  hide: {
    start: (detail) => {
      fullcontEntity.hide(detail, htmlFc);
    },
  },
  prepareAdd: {
    start: (detail) => {
      fullcontEntity.prepareAdd(detail, htmlFc);
    },
  },
  prepareEdit: {
    start: (detail) => {
      fullcontHandler.prepareEdit(detail, htmlFc);
    },
  },
  saveFromDialog: {
    start: (detail) => {
      handler.validate(detail, htmlFc);
    },
  },
  selectOne: {
    start: (detail) => {
      fullcontEntity.selectOne(detail, htmlFc);
    },
  },
  selectOneNoCheck: {
    start: (detail) => {
      fullcontEntity.selectOneNoCheck(detail, htmlFc);
    },
  },
  update: {
    start: (detail) => {
      handler.validate(detail, htmlFc);
    },
  },
  callData: {
    start: (detail) => {
      callData(detail, htmlFc);
    },
  },
  callUnpaidInvoices: {
    start: (detail) => {
      callUnpaidInvoices(detail, htmlFc);
    },
  },
  click: {
    start: (detail) => {
      click(detail, htmlFc);
    },
  },
  printReportAll: {
    start: (detail) => {
      printReportAll(detail, htmlFc);
    },
  },
  printReportOne: {
    start: (detail) => {
      printReportOne(detail, htmlFc);
    },
  },
  purchaseFullcont2: {
    start: (detail) => {
      purchaseFullcont2(detail, htmlFc);
    },
  },
}; /**/

function purchaseFullcont2(detail, htmlFc) {
  accountsPayable.start({
    dest: detail.dest,
    elem: "purchaseFullcont2",
    id: "purchase-fullcont2",
    act: "showFullcont",
    dbid: detail.dbid,
  });
}

//function to send
function editDialog() {
  dialog.start({
    act: "show",
    id: "saveChanges",
    entity: "accountsPayable",
  });
}

function deleteDialog(detail) {
  dialog.start({
    act: "show",
    dest: "accountsPayable",
    id: "deleteElem",
    entity: "accountsPayable",
    dbid: detail.dbid,
  });
}

function dtCall(act, result) {
  accountsPayableDt.start({ act: act, row: result });
}

function addOne(detail, htmlFc) {
  fullcontEntity.addOne(detail, htmlFc);
  setTimeout(() => {
    // accountsPayableDt.start({"dest":"accountsPayable", "elem":"dt", "act":"select", "entity":"accountsPayable"})
  }, 100);
}

function deleteFromDialog(detail, htmlFc) {
  if (parseInt(htmlFc.fullcontHTML.getAttribute("data-DBid")) > 99) {
    fullcontEntity.deleteFromDialog(detail, htmlFc);
    setTimeout(() => {
      accountsPayableDt.start({
        dest: "accountsPayable",
        elem: "dt",
        act: "select",
        entity: "accountsPayable",
      });
    }, 900);
  } else {
    snack.start({ act: "show", id: "accountidisless" });
  }
}

function callData(detail, htmlFc) {
  const fetchDetail = {
    dest: "provider",
    elem: "report",
    reportType: "accountPayableAll",
    dbid: detail.dbid,
  };

  accountsPayableFetch.fetchOne(fetchDetail, (data) => {
    fullcontReport.showFullcont(detail, data, {
      id: "#accountsPayable_form_",
      fields: [
        "provider",
        "current",
        "total_due",
        "total_due_30_days",
        "total_due_31_to_60_days",
        "total_due_61_to_90_days",
        "total_due_over_90_days",
      ],
    });

    topData = data;
    tryGenerateAndInsert();
  });
}

function callUnpaidInvoices(detail, htmlFc) {
  const container = document.getElementById("multitable-report-payable");

  const fetchDetail = {
    dest: "provider",
    elem: "report",
    reportType: "accountPayable",
    dbid: detail.dbid,
  };

  accountsPayableFetch.fetchUnpaidInvoices(fetchDetail, (data) => {
    fullcontReport.renderUnpaidInvoices(data, {
      container: container,
      lineRenderer: MtGenerator.unpaid_invoices_list,
      headerHtml: `
        <div class="o54">
          <div class="row">
            <div class="c20"><label class="font-caption label-report">Date</label></div>
            <div class="c20"><label class="font-caption label-report">Code</label></div>
            <div class="c20"><label class="font-caption label-report">Due Date</label></div>
            <div class="c20"><label class="font-caption label-report">Original Amount</label></div>
            <div class="c20"><label class="font-caption label-report">Due Amount</label></div>
          </div>
        </div>
      `,
      afterLineRender: (line, item) => {
        fullcontReport.autoAssignValuesByClass(line, item);
      },
    });

    tableData = data;
    tryGenerateAndInsert();
  });
}

function printHtmlInIframe(html) {
  // Si el iframe ya está en about:blank y listo, imprime de inmediato
  const doc = iframe.contentWindow.document;

  if (
    iframe.contentWindow &&
    iframe.contentWindow.location.href === "about:blank"
  ) {
    doc.open();
    doc.write(
      "<!DOCTYPE html><html><head></head><body>" + html + "</body></html>"
    );
    doc.close();
    iframe.contentWindow.print();
    iframe.onload = null;
  } else {
    // Si no, espera a que cargue about:blank
    iframe.onload = function () {
      doc.open();
      doc.write(
        "<!DOCTYPE html><html><head></head><body>" + html + "</body></html>"
      );
      doc.close();
      iframe.contentWindow.print();
      iframe.onload = null;
    };
  }
  iframe.src = "about:blank";
}

function printReportAll(detail, htmlFc) {
  // console.log("print >", detail);

  const dataCont = document.querySelector(".accountsPayable-dataCont");
  printHtmlInIframe(dataCont.innerHTML);
}

function printReportOne(detail, htmlFc) {
  const dataCont = document.querySelector(".accountsPayable-one");
  printHtmlInIframe(dataCont.innerHTML);
}

function tryGenerateAndInsert() {
  if (topData && tableData) {
    const container = document.querySelector(
      "#accountsPayable-page-right .dataContPayable"
    );

    if (!container) {
      console.error("Contenedor no encontrado.");
      return;
    }

    const html = generate(topData, tableData);
    container.innerHTML = ""; // opcional: limpiar antes
    container.insertAdjacentHTML("beforeend", html);

    topData = null;
    tableData = null;
  }
}

function generate(top, table) {
  //return

  var body = "";
  body += generateHeader();
  body += generateTop(top[0]);
  body += generateTable(table);
  body += `</div> <!-- dataCont -->`;
  body += `<div class="report-page">`;

  return body;
}

function generateHeader() {
  var header = "";
  header += `<div class="report-page" id="miDiv5" ${css.table}>`;
  header += `
                      <div class="report-appbar report-appbar-black" >
  
                              <div  data-detail='{"click": [ 
                                                          {"dest":"ripple" }, 
                                                          {"dest":"provider", "elem":"report", "reportType":"accountPayableAll"} ] }' >
                                  <svg fill="#ffffff" version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M38.454,13.627c-0.759-0.804-2.024-0.839-2.827-0.081l-18,17C17.227,30.924,17,31.45,17,32s0.227,1.076,0.627,1.454l18,17 C36.013,50.819,36.507,51,37,51c0.531,0,1.061-0.21,1.455-0.627c0.758-0.803,0.722-2.069-0.081-2.827L21.913,32l16.46-15.546 C39.176,15.696,39.212,14.43,38.454,13.627z"></path> <path d="M32,0C23.453,0,15.417,3.329,9.374,9.373C3.329,15.417,0,23.453,0,32s3.33,16.583,9.374,22.626 C15.417,60.671,23.453,64,32,64s16.583-3.329,22.626-9.373C60.671,48.583,64,40.547,64,32s-3.33-16.583-9.374-22.626 C48.583,3.329,40.547,0,32,0z M51.797,51.798C46.509,57.087,39.479,60,32,60s-14.509-2.913-19.798-8.202C6.913,46.51,4,39.479,4,32 s2.913-14.51,8.203-19.798C17.491,6.913,24.521,4,32,4s14.509,2.913,19.798,8.202C57.087,17.49,60,24.521,60,32 S57.087,46.51,51.797,51.798z"></path> </g> </g></svg>
                              </div>
  
                              <h1>Provider Statement: Account Payable Aging Report</h1>
  
                          <div class="fr" data-detail='{"click": [ 
                                                      {"dest":"ripple" }, 
                                                      {"dest":"report", "act":"print" }  ] }' >
                                  <svg><use xlink:href="../css/svg.svg#print"></use></svg>
                                  <label>Print</label>
                          </div>
                      </div> <!-- appbar -->
              `;

  header += `
                      <div class="dataCont accountsPayable-one">
                          <h1  ${css.f32}> </h1>
                          <p   ${css.f14} ></p>
              `;
  return header;
}

function generateTop(data) {
  var table = `<br><br><h1 style="text-align: center;">${data.company_name}</h1>
    <h3 style="text-align: center;">${data.provider} Account Payable Aging Report As Of ${data.current_dateTime}</h3>
    `;

  return table;
} /**/

function generateTable(agesData) {
  var totalDue = 0;

  var table = `
              <h2 ${css.f15}>${
    agesData[0].name + " Unpaid Bills"
  }: This is a financial document that provides a summary of the outstanding invoices and bills that a company owes to one Provider.</h2>
              <table ${css.table} >
              <tr >
               
                <th ${css.th}>Date</th>
                <th ${css.th}>Category</th>
                <th ${css.th}>code</th>   
                <th ${css.th}>Due Date</th>  
                <th ${css.th}>Due Amount</th>         
                <th ${css.th}>Original Amount</th>
               
                
              </tr> 
            `;
  //SI EL REPORTE RETIRNO NADA
  if (agesData[0].ageDueAmount == null) {
    table += `
                <tr>
                  <td ${css.td} colspan="6"  ><div align="center"><h3>No Due Bills Were Found.</h3></div></td>
                </tr> 
              `;
    table += `</table>`;

    return table;
  }

  for (let i = 0; i < agesData.length; i++) {
    table += `
                      <tr>
                        <td ${
                          css.td
                        } colspan="6" bgcolor="lightgray" ><div align="center"><h3>${
      agesData[i].overdue_age + " " + agesData[i].ageDueAmount
    }</h3></div></td>
                      </tr> 
                  `;

    totalDue += parseFloat(agesData[i].ageDueAmount.replace(/[$,]/g, ""));

    var ageUnpaidBill = JSON.parse(agesData[i].unpaidBill);

    for (let y = 0; y < ageUnpaidBill.length; y++) {
      let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },  
                                  {"dest":"report", "elem":"fullcont",  "act":"jump", 
                                  "actJump":"goToPurchase", "dtId":"purchase-dt", "toSearch":"${ageUnpaidBill[y].code}"  } ] }'`;

      table += `
                        <tr ${rowStyle(i + y)}>
                              
                              <td ${css.td} >${ageUnpaidBill[y].date}</td>
                              <td ${css.td} >${ageUnpaidBill[y].category}</td>
                              <td class='tdClick' ${css.td} ${detailHtml} >${
        ageUnpaidBill[y].code
      }</td>
                              <td ${css.td} >${ageUnpaidBill[y].due_date}</td>
                              <td ${css.td} >${ageUnpaidBill[y].due_amount}</td>
                              <td ${css.td} >${
        ageUnpaidBill[y].original_amount
      }</td>
                              
                            
                            </tr> 
                        `;
    }
  }

  table += `
          <tr>
            <td ${
              css.td
            } colspan="5"  ><div align="right"><h1>Total Due</h1></div></td><td ${
    css.td
  } ><div align="left"><h1>${cashVal(totalDue)}</h1></div></td>
          </tr> 
      `;
  table += `</table>`;

  return table;

  function cashVal(value) {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }
  function rowStyle(i) {
    if (i % 2 === 0) {
      return "";
    }
    return css.trGray;
  }
}
